import { useEffect, useState, FC, ReactNode } from 'react';
import { useTenantPermissions } from '@maxtropy/components';
import noAuthImg from '@/assets/images/notAuthorizedLight.png';
import styles from './index.module.scss';
import { Empty } from 'antd';

interface AuthorizedPermissionProps {
  permissionKey: string | string[];
  children?: ReactNode;
}

const AuthorizedPermission: FC<AuthorizedPermissionProps> = props => {
  const { permissionKey, children } = props;
  const [loading, setLoading] = useState<boolean>(true);
  const [state, setState] = useState(false);

  const permission = useTenantPermissions();

  useEffect(() => {
    if (permission) {
      let state: boolean;
      if (Array.isArray(permissionKey)) {
        state = permissionKey.map(i => permission.includes(i)).some(i => i);
      } else {
        state = permission.includes(permissionKey);
      }
      setState(state);

      setLoading(false);
    }
  }, [permission, permissionKey]);

  return state ? (
    children
  ) : (
    <div className={styles.pageNotAuthorized}>
      <Empty
        image={noAuthImg}
        description={
          <div className={styles.description}>
            <span>您没有权限访问此页面</span>
            <span>请联系管理员</span>
          </div>
        }
      />
    </div>
  );
};

export default AuthorizedPermission;
